import React, { useState } from 'react';
import { CheckboxHeaderWrapper, StyledCheckbox, Hint } from '../styles';
import Portal from '../AddressCell/Portal';


const CheckboxHeaderCell = ({ setSelectedRows, isAllSelected, allRowIndices }) => {
    const [showHint, setShowHint] = useState(false);
    return (
        <CheckboxHeaderWrapper
            onMouseEnter={() => setShowHint(true)}
            onMouseLeave={() => setShowHint(false)}
        >
            <StyledCheckbox
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) => {
                    if (e.target.checked) {
                        setSelectedRows(allRowIndices);
                    } else {
                        setSelectedRows([]);
                    }
                }}
            />
            {showHint && (
                <Hint>
                    {isAllSelected ? 'Unselect All' : 'Select All'}
                </Hint>
            )}
        </CheckboxHeaderWrapper>
    )
}
export default CheckboxHeaderCell;
